export const FrontLeft = () => (
	<svg
		style={{
			position: 'absolute',
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			pointerEvents: 'none',
		}}
		viewBox="-40 -40 522 845"
		preserveAspectRatio="xMidYMid meet"
		overflow="visible"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			fill="rgba(0,0,0,0.7)"
			d="M-99999 -99999 H99999 V99999 H-99999 Z M368.5 232.5c14.54.68 23.69 5.63 25.7 21 1.07 8.21-3.78 7.74 1.53 15 18.13 24.78 40.38 48.87 51.35 78 5.74 15.28 6.64 31.04 8.84 47l5.62 60 .96 13v55l-1 16-3.84 47c-2.87 26.9-4.92 45.78-16.47 71-12.22 26.7-31.19 46.69-52.69 66.17-15.36 13.92-7.03 17.39-25 32.62-9.19 7.79-21.81 6.03-33 7.39-6.26.76-7.01 2.71-16 2.82l-30-1c-7.83-.1-28.09-2.95-36-4.66l-16-4.26h-12c-14.14-1.6-28.39-3.08-42-7.42-13.92-4.45-27.34-8.95-28.68-25.66l.68-11c.1-7.79 1.9-28.79 5.84-34.99 2.86-4.49 7.07-6.97 12.16-8.01-2.33-8.17-11.51-23.26-15.74-32l-28.95-61-6.94-15-5.05-9c-1.56-3.27-4.23-11.2-6.73-13.26-2.24-1.84-7.66-2.33-10.59-2.82l-21-4.64c-25.24-7.49-62.82-22.7-70.96-50.28-2.16-7.34-1.6-14.51-.87-22 1.29-13.32 5.6-36.03 11.14-48 4.52-9.77 8.74-10.7 10.38-15l1.31-11c1.53-7.87 6.3-28.32 9.35-35 3.81-8.33 9.12-8.9 11.05-14.01l1.77-17.99 6.31-41c3.35-13.09 7.55-14.94 9.58-22l5.99-36 3.57-9 9.8-48 5.97-28-1.39-15c-.02-13.15.54-22.59 5.87-35 2.6-6.05 4.88-8.16 7.48-13l5.09-21c2.38-7.64 4.61-6.5 6.31-16 1.25-6.99 3.58-20.47 9.46-24.87 7.47-5.58 25.42-4.21 34.79-4.13h13l21-1 10-.91 23-1.37c5.98-.22 12.01-1.57 18 0 9.47 1.98 25.18 14.15 30 16.2 6.13 2.6 13.1.06 24 8.01 13.59 9.9 22.82 25.26 30.25 40.07 8.83 17.63 13.65 35.05 18.63 54l14.72 62z"
		/>
	</svg>
);
